export default "__VITE_ASSET__DxP1Df_6__"